import type { GridSortModel } from '@packages/fenrir/components';

import { getSessionGridState } from './get-session-grid-state';

export const getInitialSortState = (
  key: string,
  defaultSort: GridSortModel,
): GridSortModel => {
  const gridState = getSessionGridState(key);
  return gridState.sorting?.sortModel
    ? gridState.sorting?.sortModel
    : defaultSort;
};
